import Subtitle from "components/Subtitle/subtitle.component";
import Table from "components/Table/table.component";
import Title from "components/Title/title.component";
import HistoricoPDRAnalisePrestacao from "./historicoPDRAnalisePrestacao";
import { PRESTACAO_CONTAS_PERMISSIONS } from "constants/index";
import dompurify from "dompurify";
import PropTypes from "prop-types";
import React, { Component } from 'react';
import { Accordion, AccordionItem } from "react-sanfona";
import { STATUS_OCORRENCIA } from "../../constants/prestacaoContas";

export default class  HistoricoAnalisePrestacao extends Component {
	render() {
		const {
			props: {
				historicos,
				actionsDocumentos,
				columnsDocumentos,
				columnsDocumentosSemTipo
			},
		} = this;
    return (
			<div className="mt-2 card">
				<div className="card-body">
					<div className="card-title">
						<Title>Histórico de análises</Title>
						<hr />
					</div>
					<div className="container">
						{/* Histórico comum a todos, vão haver os modelos aqui */}
						<HistoricoComum historicos={historicos} />

						{/*
						Entrega imediata ou PDR
						Componente do PDR não foi criado ainda, porque não tem como saber como virá as infos
					*/}
						{historicos.forma.nome === "Entrega imediata" && (
							<HistoricoEntregaImediata historicos={historicos} />
							)}

						{historicos.forma.nome === "PDR" && <HistoricoPDRAnalisePrestacao historicos={historicos}/>}

						{/* Renderiza a lista de historico das análises */}
						<HistoricoAnalises
							historicos={historicos}
							actionsDocumentos={actionsDocumentos}
							columnsDocumentos={columnsDocumentos}
							columnsDocumentosSemTipo={columnsDocumentosSemTipo}
							/>
					</div>
				</div>
			</div>
		);
	}
}

function getStatus(historico, statusOcorrencia) {
	if (
		(((historico || {}).historicoDaca || {}).ocorrencia || {})
			.statusOcorrencia !== undefined ||
		(((historico || {}).historicoDaca || {}).ocorrencia || {})
			.statusOcorrencia
	) {
		const existe = historico.historicoDaca.ocorrencia.statusOcorrencia.filter(
			status => status.codigo === statusOcorrencia
		);
		if (existe.length > 0) {
			return true;
		}
	}
	return false;
}

const HistoricoComum = ({ historicos }) => (
	<>
		<Subtitle>Documentação</Subtitle>
		<hr />
		<Accordion className="mb-1">
			<AccordionItem title="Decreto municipal" titleTag="h5">
				{getStatus(historicos, STATUS_OCORRENCIA.EMERGENCIA) ||
					getStatus(historicos, STATUS_OCORRENCIA.CALAMIDADE) ? (
						<>
							<div>
								<strong>Status: </strong>
								{getStatus(historicos, STATUS_OCORRENCIA.EMERGENCIA)
									? "Emergência"
									: "Calamidade"}
							</div>
							<div>
								<strong>Nº do decreto: </strong>{" "}
								{historicos.infoStatus
									? historicos.infoStatus.numeroDecreto
									: "--"}
							</div>

							<div>
								<strong>Data do decreto: </strong>
								{historicos.infoStatus
									? historicos.infoStatus.dataDecreto
									: "--"}
							</div>
						</>
					) : (
						<SemInformacoes />
					)}
			</AccordionItem>

			<AccordionItem title="Homologação" titleTag="h5">
				{getStatus(historicos, STATUS_OCORRENCIA.HOMOLOGADO) ? (
					<>
						<div>
							<strong>Nº do DOE: </strong>
							{historicos.infoStatus
								? historicos.infoStatus.numeroDoe
								: "--"}
						</div>
						<div>
							<strong>Data de publicação: </strong>
							{historicos.infoStatus
								? historicos.infoStatus.dataPublicacaoDoe
								: "--"}
						</div>
						<div>
							<strong>Nº da página: </strong>
							{historicos.infoStatus
								? historicos.infoStatus.numeroPaginaDoe
								: "--"}
						</div>
					</>
				) : (
						<SemInformacoes />
					)}
			</AccordionItem>

			<AccordionItem title="Reconhecimento" titleTag="h5">
				{getStatus(historicos, STATUS_OCORRENCIA.RECONHECIDO) ? (
					<>
						<div>
							<strong>Nº do DOU: </strong>
							{historicos.infoStatus
								? historicos.infoStatus.numeroDou
								: "--"}
						</div>
						<div>
							<strong>Data de publicação: </strong>{" "}
							{historicos.infoStatus
								? historicos.infoStatus.dataPublicacaoDou
								: "--"}
						</div>
						<div>
							<strong>Nº da página: </strong>{" "}
							{historicos.infoStatus
								? historicos.infoStatus.numeroPaginaDou
								: "--"}
						</div>
					</>
				) : (
						<SemInformacoes />
					)}
			</AccordionItem>
		</Accordion>
	</>
);

/* Componente para se a forma for de entrega imediata */
const HistoricoEntregaImediata = ({ historicos }) => (
	<>
		<Subtitle>Saída DACA</Subtitle>
		<hr />
		<Accordion className="mb-1">
			<AccordionItem title="Registro de saída DACA" titleTag="h5">
				<div className="row">
					<div className="col-md-6">
						<p>
							<strong>Item: </strong>{" "}
							{historicos.historicoDaca.daca.nome || "--"}{" "}
						</p>
					</div>
					<div className="col-md-6">
						<p>
							<strong>Quantidade: </strong>{" "}
							{historicos.historicoDaca.quantidadeEntradaSaida ||
								"--"}{" "}
						</p>
					</div>
				</div>
				<div className="row">
					<div className="col-md-6">
						<p>
							<strong>Data/Hora: </strong>{" "}
							{historicos.dataCadastro || "--"}{" "}
						</p>
					</div>
					<div className="col-md-6">
						<p>
							<strong>Responsável: </strong>{" "}
							{historicos.historicoDaca.responsavel || "--"}{" "}
						</p>
					</div>
				</div>
			</AccordionItem>
		</Accordion>
	</>
);

/* Sanitiza o innerHtml, para não previnir ataques de injeção por XSS
	Foi usado o innerHTML para ser renderizado as tags que vem do campo observações
*/
function innerHTMLPurified(text) {
	const textToBeSanitizer = text;
	const sanitizer = dompurify.sanitize;

	// eslint-disable-next-line react/no-danger
	return (
		<div
			dangerouslySetInnerHTML={{
				__html:
					sanitizer(textToBeSanitizer) ||
					"Não há observações cadastradas."
			}}
		/>
	);
}

/* Renderiza a lista de historico das análises */
const HistoricoAnalises = ({
	historicos,
	actionsDocumentos,
	columnsDocumentos,
	columnsDocumentosSemTipo
}) => (
		<>
			<Subtitle>Histórico de análises</Subtitle>
			<hr />
			{/* Verifica se há análises */}
			{historicos.analises.length === 0 ? (
				<SemInformacoes />
			) : (
					<Accordion>
						{historicos.analises.map(analise => (
							<AccordionItem
								title={analise.etapaProcesso}
								key={analise.id}
								titleTag="h5"
							>
								<div className="container">
									<p>
										<strong>Responsável: </strong>
										{analise.responsavel || "--"}
									</p>

									<p>
										<strong>Data/Hora da ação: </strong>
										{analise.dataAcao || "--"}
									</p>

									<DocumentosAnexados
										actionsDocumentos={actionsDocumentos}
										columnsDocumentos={columnsDocumentos}
										analise={analise}
										columnsDocumentosSemTipo={
											columnsDocumentosSemTipo
										}
									/>

									<CampoObservacoes analise={analise} />
								</div>
							</AccordionItem>
						))}
					</Accordion>
				)}
		</>
	);

const DocumentosAnexados = ({
	actionsDocumentos,
	columnsDocumentos,
	analise,
	columnsDocumentosSemTipo
}) => (
		<>
			<Subtitle>Documentos anexados</Subtitle>
			<hr />
			<Table
				align="left"
				acoesSingleButton
				actions={actionsDocumentos}
				columns={
					analise.localProcesso.id === 1
						? columnsDocumentos
						: columnsDocumentosSemTipo
				}
				data={analise.documentos}
				showPaginate={false}
				emptyMessage="Não há registros cadastrados."
				emptyColSpan={columnsDocumentos.length + 1}
				permission={[PRESTACAO_CONTAS_PERMISSIONS.VISUALIZAR]}
			/>
		</>
	);

const CampoObservacoes = ({ analise }) => (
	<>
		<Subtitle>Observações</Subtitle>
		<hr />
		{innerHTMLPurified(analise.observacoes)}
	</>
);

const SemInformacoes = () => (
	<span>Não existem informações a serem exibidas.</span>
);

HistoricoAnalisePrestacao.propTypes = {
	historicos: PropTypes.shape({
		historicoDaca: PropTypes.object.isRequired
	}).isRequired,
	actionsDocumentos: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.number,
			etapaProcesso: PropTypes.string,
			property: PropTypes.string
		})
	).isRequired,
	columnsDocumentos: PropTypes.arrayOf(
		PropTypes.shape({
			name: PropTypes.string,
			icon: PropTypes.string,
			action: PropTypes.func
		})
	).isRequired
};

